import { STORAGE_ITEM_ANALYTICS_BANNER_DESTINATION } from '@wwe-portal/web/utils/constants/keys';
import { sendSysUI, sendCommonTitanEvent } from './common';
import { sendGTMEvent } from './gtm-helper';

export const sendUserClickBackToGame = () => {
  sendSysUI({
    flow_name: 'web_portal',
    screen_type: 'screen',
    interaction_type: 'tap',
    interaction_object: 'back_to_game',
    interaction_object_category: '',
    screen_content: '',
    screen_subcategory: '',
    flow_order: null,
  });
};

export const sendUserExpandMenuGroup = ({
  groupName,
  items,
}: {
  groupName: string;
  items: string[];
}) => {
  sendSysUI({
    flow_name: 'web_portal',
    screen_type: 'screen',
    screen_category: 'burger_menu',
    interaction_type: 'tap',
    interaction_object: groupName,
    interaction_object_category: '',
    screen_content: JSON.stringify({
      parent_item: groupName,
      sub_items: items,
    }),
    screen_subcategory: '',
    flow_order: null,
  });
};

export const sendUserClickMenuGroupItem = ({
  groupName,
  itemName,
}: {
  groupName?: string;
  itemName: string;
}) => {
  sendSysUI({
    flow_name: 'web_portal',
    screen_type: 'screen',
    screen_category: 'burger_menu',
    interaction_type: 'tap',
    interaction_object: itemName,
    interaction_object_category: '',
    screen_content: JSON.stringify({
      parent_item: groupName,
      action_item: itemName,
    }),
    screen_subcategory: '',
    flow_order: null,
  });
};

const setHighlightBannerDestination = (destination: string) => {
  sessionStorage.setItem(
    STORAGE_ITEM_ANALYTICS_BANNER_DESTINATION,
    destination
  );
};

const getHighlightBannerDestination = () => {
  return sessionStorage.getItem(STORAGE_ITEM_ANALYTICS_BANNER_DESTINATION);
};

const clearHighlightBannerDestination = () => {
  return sessionStorage.removeItem(STORAGE_ITEM_ANALYTICS_BANNER_DESTINATION);
};

export const sendHighlightBannerClick = ({
  itemName,
  destination,
  index,
}: {
  itemName: string;
  destination: string;
  index: number;
}) => {
  setHighlightBannerDestination(destination);
  sendSysUI({
    flow_name: 'web_portal',
    screen_type: 'screen',
    screen_category: 'dashboard',
    interaction_type: 'tap',
    interaction_object: itemName,
    interaction_object_category: '',
    screen_content: JSON.stringify({
      item_name: itemName,
      section: 'featured',
      position_inside_category: index + 1,
    }),
    screen_subcategory: '',
    flow_order: null,
  });
};

const isAbsoluteUrl = (url: string) =>
  url.indexOf('http://') === 0 || url.indexOf('https://') === 0;

const tryGetPathname = (destination: string | null) => {
  if (destination == null) return null;
  try {
    if (isAbsoluteUrl(destination)) {
      return new URL(destination).pathname;
    }
    return new URL(destination, document.baseURI).pathname;
  } catch {
    return null;
  }
};

export const sendHighlightBannerDestinationLoad = (pathname: string) => {
  const destination = getHighlightBannerDestination();
  const destinationPathname = tryGetPathname(destination);
  if (destinationPathname && destinationPathname === pathname) {
    sendSysUI({
      flow_name: 'web_portal',
      screen_type: 'screen',
      interaction_type: 'load',
      interaction_object_category: '',
      screen_content: JSON.stringify({
        url: destination,
      }),
      screen_subcategory: '',
      flow_order: null,
    });
  }
  clearHighlightBannerDestination();
};

export const sendAppOpenEvent = ({
  isWarmStart,
  userId,
}: {
  isWarmStart: boolean;
  userId?: string;
}) => {
  sendCommonTitanEvent('sys.app_open', {
    is_warm_start: isWarmStart,
    tenant: userId || '',
  });
};

export const sendGTMGlobalSearch = (searchValue: string) => {
  sendGTMEvent({
    category: 'Global Search',
    event: 'global_search_typed',
    action: `global-search/${searchValue}`,
  });
};
